<igx-card-header class="dialog-header" style="z-index: 999;" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container" cdkDragHandle [cdkDragDisabled]="outIsFullScreen">
    {{title}}
</igx-card-header>
<button igxButton="flat" class="btn-screen-mode col-auto igx-primary-btn close-button" appMatDialogFullScreen="false"
    style="--component-size: var(--ig-size, var(--ig-size-medium));" (outFullScreen)="isDialogDrag($event)">
    <div *ngIf="!outIsFullScreen">
        <mat-icon class="close-icon">fullscreen</mat-icon>
    </div>
    <div *ngIf="outIsFullScreen">
        <mat-icon class="close-icon">fullscreen_exit</mat-icon>
    </div>
</button>
<button igxButton="flat" class="col-auto igx-primary-btn close-button" (click)="closeDialog()"
    style="--component-size: var(--ig-size, var(--ig-size-medium));">
    <igx-icon class="close-icon" color="warn">close</igx-icon>
</button>
<div (resize)="onResize($event)" style="height: calc(100% - 100px); overflow: auto;">
    <div style="box-shadow:none;" style="height:100%">
        <div #canvasContainer class="editor-container">
            <canvas #fabricCanvas></canvas>
        </div>
        <div class="floating-toolbar">
            <!-- Highlight -->
            <button *ngIf="activeTool !== 'crop'" class="tool-btn" [class.active]="activeTool === 'highlight'" title="Highlight"
                (click)="enableHighlight()">
                <igx-icon>rectangle</igx-icon>
            </button>
            <!-- Pen -->
            <button *ngIf="activeTool !== 'crop'" class="tool-btn" [class.active]="activeTool === 'pen'" title="Draw" (click)="enablePen()">
                <igx-icon>gesture</igx-icon>
            </button>
            <!-- Pen Width -->
            <div *ngIf="activeTool !== 'crop'" class="width-picker">
                <input type="range" min="1" max="50" [(ngModel)]="selectedWidth" (ngModelChange)="onPenSettingChange()" title="Pen Width">
                <span>{{ selectedWidth }}</span>
            </div>
            <!-- Color Picker -->
            <input *ngIf="activeTool !== 'crop'" type="color" class="color-picker" [(ngModel)]="selectedColor" (ngModelChange)="onPenSettingChange()" title="Select Color">
            <!-- Undo -->
            <button *ngIf="activeTool !== 'crop'" class="tool-btn" title="Undo" (click)="undo()">
                <igx-icon>undo</igx-icon>
            </button>

            <!-- Clear -->
            <!-- <button class="tool-btn" [igxTooltipTarget]="Clear" (click)="clearAnnotations()">
                <igx-icon>layers_clear</igx-icon>
            </button> -->

            <!-- Crop -->
            <button class="tool-btn" [class.active]="activeTool === 'crop'" title="Crop" (click)="enableCrop()">
                <igx-icon>crop</igx-icon>
            </button>
            <button *ngIf="activeTool === 'crop'" class="tool-btn" title="Apply Crop" (click)="applyCrop()">
                <igx-icon>check</igx-icon>
            </button>
            <button *ngIf="activeTool === 'crop'" class="tool-btn" title="Apply Crop" (click)="ClearCrop()">
                <igx-icon>close</igx-icon>
            </button>

            <div class="toolbar-divider"></div>
            <!-- Confirm -->
            <button *ngIf="activeTool !== 'crop'" class="tool-btn success-btn" title="Confirm" (click)="saveEditedImage()">
                <igx-icon>check</igx-icon>
            </button>
            <!-- Close -->
            <button class="tool-btn danger-btn" title="Close" (click)="closeEditor()">
                <igx-icon>close</igx-icon>
            </button>
        </div>
    </div>
</div>